export default __webpack_public_path__ + "static/Natural_Light_Indoor_2560kbps-b05bc8dae6e5b45047b95bbfcf0696b0.avif";